import { render, staticRenderFns } from "./UserRealtimeBox.vue?vue&type=template&id=08bb10b8"
import script from "./UserRealtimeBox.vue?vue&type=script&lang=js"
export * from "./UserRealtimeBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports